import React from 'react';

export class PageHeading extends React.Component<{ children: React.ReactNode }> {
  render() {
    return (
      <div className="row">
        <div className="col">
          <h3>{this.props.children}</h3>
        </div>
      </div>
    );
  }
}
